/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useAuth } from '@context';
import { Outlet, useSearchParams } from 'react-router-dom';
import { NavigationItemList } from '@components/Navigation/types';
import {
  useNovuNotifications,
  useNovuConfig,
  UserRoleService,
} from '@services';
import {
  clientNavigation,
  managerNavigation,
} from '@views/RequireAuth/navigationItems';
import { NOVU_BACKEND_URL, NOVU_SOCKET_URL } from '@constants';
import { Navigation } from '@components/Navigation';
import { useSetAtom } from 'jotai';
import { isPublicPageAtom } from '../../store/jotai';

export function PublicPage() {
  const setIsPublicPage = useSetAtom(isPublicPageAtom);
  const { isWarehouseManager } = UserRoleService();
  const { isAuthenticated, user } = useAuth();
  const [searchParams] = useSearchParams();

  const { config: novuConfig, loading: configLoading } = useNovuConfig();

  // Initialize Novu notifications for public page users (if authenticated)
  const notificationToken = localStorage.getItem('notificationToken');
  useNovuNotifications({
    applicationIdentifier: novuConfig?.applicationIdentifier!,
    subscriberId: user?.id || '',
    subscriberHash: notificationToken || undefined,
    backendUrl: NOVU_BACKEND_URL,
    socketUrl: NOVU_SOCKET_URL,
    isInitialisingNovu:
      isAuthenticated &&
      !!user?.id &&
      !!notificationToken &&
      !configLoading &&
      !!novuConfig?.applicationIdentifier,
  });

  const role = searchParams.get('role') || '';

  const buildNavigationItems = (): NavigationItemList =>
    isWarehouseManager(user) || role === 'logistics-provider'
      ? managerNavigation
      : clientNavigation;

  setIsPublicPage(true);

  return (
    <Navigation items={buildNavigationItems()}>
      <Outlet />
    </Navigation>
  );
}
